export default "__VITE_ASSET__kM04LtXN__"